import { ChatSelectors } from "./Slice";
export const allChatMessagesSelector = (state) => ChatSelectors.selectAll(state.chat);
